export const palette = {
  backgroundColor: 'white',
  primary: { main: '#e09909', light: '#fff7e6', dark: '#d48e02' },
  grey: { main: '#F5F5F5', light: '#F5F5F5', dark: '#F5F5F5' },
} as const
